import { observer } from "mobx-react-lite";

import { ConfigSidebar } from "src/components/SidebarConfigSidebar";

import { useLayoutSettingsContext } from "./LayoutSettingsContext";

export const Sidebar = observer(function Sidebar() {
  const layoutSettings = useLayoutSettingsContext();

  if (!layoutSettings.sidebar) {
    return null;
  }

  return <ConfigSidebar config={layoutSettings.sidebar} />;
});
